<template>
  <div :class="$style.row">
    <ItemRow
      v-bind="$attrs"
      :selected="itemData.selected"
      v-on="$listeners"
    >
      <ItemWithLabel
        :class="$style.displayFlex"
        :column="columns[0]"
      >
        <StatusBadge
          :class="$style.marginTopBadge"
          :status="findStatus"
          :text="findStatusText"
        />
      </ItemWithLabel>
      <ItemWithLabel
        :column="columns[1]"
      >
        {{ itemData.displayName }}
      </ItemWithLabel>
      <ItemWithLabel
        :column="columns[2]"
      >
        <Icon
          :class="$style.marginTopIcon"
          icon="android"
          :scale="2"
        />
        <span :class="$style.iconLabel"> {{ itemData.os }} </span>
      </ItemWithLabel>
    </ItemRow>
  </div>
</template>

<script>
import {
  Icon,
  ItemRow,
  ItemWithLabel,
  StatusBadge,
} from '@jumpcloud/ui-components';

export default {
  name: 'GoogleAppsDeviceRow',
  components: {
    Icon,
    ItemRow,
    ItemWithLabel,
    StatusBadge,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },
    itemData: {
      required: true,
      type: Object,
    },
  },

  computed: {
    findStatus() {
      return this.itemData.active ? 'success' : 'error';
    },

    findStatusText() {
      return this.itemData.active ? 'Active' : 'Inactive';
    },
  },
};
</script>

<style module>
.row {
  border-bottom: var(--jc-border);
}

.displayFlex {
  display: flex;
}

.marginTopIcon {
  margin-top: -0.313rem;
}

.marginTopBadge {
  margin-top: -0.188rem;
}

.iconLabel {
  margin-left: var(--jc-spacer-x-small);
  position: absolute;
  text-align: center;
}
</style>
